@import 'styles/mixins';

.container {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  gap: 30px;
  flex: 1 0 0;
  width: 100%;

  .header {
    align-items: center;
    display: flex;
    justify-content: space-between;
    width: 100%;
    padding: 0;
    border-bottom: none;

    .headerTitle {
      font-size: 20px;
      font-weight: 400;
      line-height: 140%;
    }

    [data-ff-settings-modal-update='on'] & {
      width: calc(100% + 80px);
      margin-left: -40px;
      padding: 16px 16px 16px 40px;
      height: 60px;
      border-bottom: 1px solid var(--dark-4);

      @include for-phone-only {
        width: 100%;
        margin-left: 0;
        padding: 16px 8px;
      }
    }
  }
}

.billingCardsRow {
  display: flex;
  align-items: stretch;
  gap: 12px;
  width: 100%;

  > *:first-child {
    flex: 1 1 0;
    min-width: 280px;
  }

  > *:last-child {
    width: 470px;
    flex-shrink: 0;
  }

  @include for-phone-only {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    flex-wrap: nowrap;
    padding: 8px 16px 8px 0;

    > *:first-child {
      flex: 0 0 302px;
      min-width: 302px;
      width: 302px;
    }

    > *:last-child {
      flex: 0 0 280px;
      min-width: 280px;
    }
  }
}

.currentPlanAndUsage {
  display: flex;
  align-items: flex-start;
  gap: 20px;
  align-self: stretch;
  flex-wrap: wrap;
}

.currentPlan {
  @include for-phone-only {
    flex: 1 1 0;
    min-width: 302px;
  }
}

.currentPlan,
.usage {
  align-items: flex-start;
  align-self: stretch;
  display: flex;
  flex-direction: column;
  gap: 10px;

  &.fullWidth {
    width: 100%;
  }
}

.usage {
  flex: 1 1 0;
  min-width: 300px;
  width: 100%;
}

.planDetails {
  align-items: flex-start;
  border-radius: 10px;
  background: var(--dark-4);
  display: flex;
  flex: 1 0 0;
  flex-direction: column;
  padding: 15px 20px 20px 20px;
  justify-content: space-between;
  width: 100%;
  height: 212px;
  gap: 10px;

  &.fullWidth {
    width: 100%;
  }

  .top {
    align-items: flex-start;
    display: flex;
    flex-direction: column;
    gap: 10px;

    .planInfo {
      align-items: flex-start;
      display: flex;
      flex-direction: column;
      gap: 8px;
      justify-content: flex-end;

      .priceAndLength {
        align-items: center;
        display: flex;
        gap: 10px;
      }
    }
  }

  .bottom {
    align-items: flex-start;
    display: flex;
    gap: 10px;

    &.fullWidth {
      flex-direction: row;
      justify-content: flex-end;
      width: 100%;
    }

    @include for-phone-only {
      width: 100%;
    }
  }
}

.freeUsageDetails {
  align-items: flex-start;
  align-self: stretch;
  background: #f8f4fc;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  gap: 15px;
  padding: 15px 20px 20px 20px;

  .referralsContainer {
    align-items: flex-start;
    align-self: stretch;
    display: flex;
    flex-direction: column;
    gap: 10px;

    .referralUrl {
      align-items: flex-start;
      align-self: stretch;
      display: flex;
      gap: 5px;

      .referralInput {
        align-items: center;
        background: var(--light-100);
        border-radius: 6px;
        border: 1px solid var(--Dark-15, rgba(0, 0, 0, 0.15));
        display: flex;
        flex-grow: 1;
        gap: 6px;
        padding: 8px;
      }
    }

    .referralButtons {
      align-items: flex-start;
      align-self: stretch;
      display: flex;
      justify-content: space-between;

      .leftButtons {
        align-items: flex-start;
        display: flex;
        gap: 4px;
      }
    }
  }
}

.usageDetails {
  border-radius: 10px;
  background: var(--dark-4);
  display: flex;
  padding: 15px 20px 20px 20px;
  flex-direction: column;
  align-items: flex-start;
  gap: 15px;
  flex: 1 0 0;
  align-self: stretch;

  .usageHeader {
    align-items: center;
    display: flex;
    justify-content: space-between;
    width: 100%;

    .titleAndUsage {
      align-items: baseline;
      align-self: stretch;
      display: flex;
      gap: 8px;
    }

    .autoReloadNotificationContainer {
      align-items: center;
      display: flex;
      gap: 8px;

      .iconAndText {
        align-items: center;
        display: flex;
        gap: 4px;
      }
    }
  }

  .creditsExpiringSoon {
    align-items: flex-end;
    display: flex;
    gap: 4px;

    span {
      padding-top: 1px;
    }
  }

  .usageFooter {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    align-self: stretch;
    margin-top: auto;
    gap: 16px;

    &.autoReload {
      align-items: unset;
      gap: 20px;
    }

    .usageBreakdown {
      display: flex;
      flex-direction: column;
      gap: 8px;

      .usageBreakdownContent {
        display: flex;
        flex-direction: column;
        gap: 6px;

        span {
          line-height: normal;
        }

        .breakdown {
          align-items: center;
          display: flex;
          gap: 5px;

          &:hover {
            cursor: help;
          }
        }
      }
    }
  }

  .usageCtaButtonContainer {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 10px;
    align-items: center;

    &.autoReload {
      gap: 12px;

      .refer {
        color: var(--dark-60);
        text-align: right;
        font-family: Sohne;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 139%;
        letter-spacing: 0.28px;
        width: 100%;
      }

      .underline {
        cursor: pointer;
        text-decoration-line: underline;
        text-decoration-style: solid;
        text-decoration-skip-ink: none;
        text-decoration-thickness: auto;
        text-underline-offset: auto;
        text-underline-position: from-font;
      }

      .ctaButtons {
        width: 100%;
        display: flex;
        gap: 10px;
        justify-content: flex-end;
      }
    }
  }
}

.serverIconAndText {
  align-items: center;
  display: flex;
  gap: 2px;
}

.tooltip {
  padding: 6px 8px;

  &.content {
    text-align: left;
  }

  &.wide {
    width: 500px;
  }
}

.getMoreCreditsAndUpgrade {
  align-items: flex-start;
  align-self: stretch;
  display: flex;
  gap: 20px;
  overflow-x: hidden;

  .upgradePlan {
    align-items: flex-start;
    display: flex;
    flex: 1 1 0;
    flex-direction: column;
    gap: 10px;
    min-width: 0;
    container-type: inline-size;
    container-name: upgradePlan;

    [data-upgrades-and-add-ons='on'] & {
      flex: 1 1 0;
    }

    .plans {
      align-items: stretch;
      align-self: stretch;
      display: flex;
      gap: 20px;
      flex-wrap: wrap;
      min-width: 0;

      [data-upgrades-and-add-ons='on'] & {
        flex-wrap: nowrap;
        min-width: 0;
      }

      @container upgradePlan (max-width: 600px) {
        overflow-x: auto;
        flex-wrap: nowrap;
        -webkit-overflow-scrolling: touch;
        padding: 8px 16px 8px 0;
      }
    }

    .starterPlanWrapper,
    .planWrapper {
      display: flex;
      flex: 1 1 0;
      flex-basis: 0;

      [data-upgrades-and-add-ons='on'] & {
        min-width: 0;
      }

      /* Override PlanDetails and AddOnCard sizing so they fit equally in billing context only */
      > div {
        width: 100%;
        flex: 1 1 0;
        min-width: 0;
      }

      @container upgradePlan (max-width: 600px) {
        flex: 0 0 280px;
        min-width: 280px;
        flex-basis: 280px;
      }
    }
  }
}

.questionsContainer {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 5px;
}

.autoReloadButton {
  align-items: center;
  background: var(--dark-3);
  border: 1px solid var(--dark-4);
  border-radius: 6px;
  color: var(--dark-90);
  display: flex;
  font-family: Sohne;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  justify-content: center;
  letter-spacing: 0.56px;
  line-height: 110%; /* 15.4px */
  padding: 6px;
  width: 48px;

  &.active {
    border-radius: 6px;
    background: var(--green-10);
    color: var(--green, #20a14f);
  }
}
